
const config = {
    defaultOptions: {
        maxHeight: 200,
        scrollOffset: -150,
        openBtnTitle: 'Show all',
        closeBtnTitle: 'Show less',
    },
    selectors: {
        expandableContainer: '.expandable-container',
        content: '.expandable-container__content',
        button: '.expandable-container__btn',
        buttonLabel: '.expandable-container__btn-label',
    },
    classNames: {
        expandableContainerExpanded: 'expandable-container--expanded',
        expandableContainerExpandable: 'expandable-container--expandable',
    },
};

class ExpandableContainer {
    constructor($rootElement, options) {
        this._$rootElement = $rootElement;
        this._options = ExpandableContainer._mergeOptions(options);
        this._elements = null;
        this._isOpen = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._setInitialState();
    }

    /**
     * Merges the options set in the data attribute
     * with the default options
     * @param {string} options - The options as a JSON string
     */
    static _mergeOptions(options) {
        if (!options) {
            return { ...config.defaultOptions };
        }

        return { ...config.defaultOptions, ...options };
    }

    /**
     * Returns an object contain the required
     * DOM elements as jQuery objects
     * @returns {object} - An object contain the DOM elements
     */
    _getDomElements() {
        const elements = {
            $button: this._$rootElement.find(config.selectors.button),
            $buttonLabel: this._$rootElement.find(config.selectors.buttonLabel),
            $content: this._$rootElement.find(config.selectors.content),
        };

        return elements;
    }

    _addEventListeners() {
        this._elements.$button.on('click', () => {
            if (this._isOpen) {
                this._closeWithTransition();
            } else {
                this._open();
            }
        });

        // if the content was opened
        // remove the fixed `max-height`
        // so the content has an auto-height
        this._elements.$content.on('transitionend', (e) => {
            if (e.target !== e.currentTarget) {
                return;
            }

            const { originalEvent } = e;
            const transitionProperty = originalEvent.propertyName;

            if (transitionProperty !== 'height') {
                // ignore other transitions than `max-height`
                return;
            }

            const contentHeight = this._getContentHeight();
            const maxHeight = parseInt(this._elements.$content.css('height'), 10);

            if (maxHeight === contentHeight) {
                // content is completly opened so now set it to auto height
                // by removing the max-height
                this._elements.$content.css('height', 'auto');
            }
        });
    }

    _setInitialState() {
        if (!this._isExpandable()) {
            return;
        }

        this._$rootElement.addClass(config.classNames.expandableContainerExpandable);
        this._close();
    }

    _refreshState() {
        if (this._isExpandable()) {
            this._$rootElement.addClass(config.classNames.expandableContainerExpandable);
        } else {
            this._close();
            this._$rootElement.removeClass(config.classNames.expandableContainerExpandable);
        }
    }

    /**
     * Checks if the content is expandable
     * by comparing the configured max-height
     * with the actual content height
     */
    _isExpandable() {
        const { maxHeight } = this._options;
        const contentHeight = this._getContentHeight();

        // "worth to scroll" behaviour for cases like maxHeight = 200 contentHeight = 210 ...
        const correction = 0.9;

        return maxHeight < (contentHeight * correction);
    }

    /**
     * Returns the height
     * of the content
     */
    _getContentHeight() {
        return this._elements.$content.prop('scrollHeight');
    }

    /**
     * Expands the container
     * by setting the height
     * to the content height
     */
    _open() {
        const contentHeight = this._getContentHeight();
        this._isOpen = true;
        this._$rootElement.addClass(config.classNames.expandableContainerExpanded);
        this._elements.$buttonLabel.text(this._options.closeBtnTitle);
        this._elements.$button.attr('title', this._options.closeBtnTitle);
        this._elements.$content.css('height', `${contentHeight}px`);
    }

    /**
     * Closes the container
     * by setting the height
     * to the configured value
     */
    _closeWithTransition() {
        const contentHeight = this._getContentHeight();
        this._elements.$content.css('height', `${contentHeight}px`);

        setTimeout(() => {
            this._close();

            setTimeout(() => {
                this._scrollToRootElement();
            }, 20);
        }, 20);
    }

    /**
     * Closes the container immediately
     * without any transition or scrolling
     */
    _close() {
        this._isOpen = false;
        this._$rootElement.removeClass(config.classNames.expandableContainerExpanded);
        this._elements.$buttonLabel.text(this._options.openBtnTitle);
        this._elements.$button.attr('title', this._options.openBtnTitle);

        const { maxHeight } = this._options;
        this._elements.$content.css('height', `${maxHeight}px`);
    }

    _scrollToRootElement() {
        $([document.documentElement, document.body]).animate({
            scrollTop: this._$rootElement.offset().top + this._options.scrollOffset,
        }, 300);
    }
}


if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $(config.selectors.expandableContainer).each((i, el) => {
        const $el = $(el);
        const options = {
            maxHeight: $el.data('max-height') || null,
            openBtnTitle: $el.data('open-btn-title') || null,
            closeBtnTitle: $el.data('close-btn-title') || null,
        };
        const expandableContainer = new ExpandableContainer($el, options);
        expandableContainer.init();
    });
};
